import { Component } from '@angular/core';
import { TableElementComponent } from '@uranda/ui';

@Component({
    selector: 'app-boolean-icon',
    template: `
    <mat-icon [ngClass]="iconClass">
      {{ iconName }}
    </mat-icon>
  `,
    styles: [
        `
      .check-success {
        color: #28a745;
      }
      .close-warn {
        color: #dc3545;
      }
    `
    ],
    standalone: false
})
export class BooleanIconComponent extends TableElementComponent {

  get value(): boolean {
    if (!this.data || !this.props) return false;
    const val = this.props.value;
    if (typeof val === 'function') {
      return val(this.data);
    }
    return !!val;
  }

  get iconName(): string {
    return this.value ? 'check' : 'close';
  }

  get iconClass(): string {
    return this.value ? 'check-success' : 'close-warn';
  }
}